import * as React from 'react';

import { FlagOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';

import { BaseTable } from 'components/modules/BaseTable';

type Props = {
    dataSource: UserBelong[],
}

const BelongsTable: React.FC<Props> = ({
    dataSource,
}) => {

    return (
        <BaseTable
            className='belongs-table'
            columns={columns}
            dataSource={dataSource}
            emptyDescription={null}
            onRow={() => ({ style: { background: 'rgba(255 255 255 / 0)' } })}
            pagination={false}
            showHeader={false}
        />
    );
};

export default BelongsTable;


const columns: ColumnsType<UserBelong> = [
    {
        key: 'organization',
        render: (_, row) => {
            return (
                <div>
                    {row.school_class.organization.name}
                </div>
            );
        },
        title: '学校',
        width: 150,
    },
    {
        key: 'class',
        render: (_, row) => {
            return (
                <div>
                    <Tag color='#AAAAAA' style={{ borderRadius: '5px', textAlign: 'center', width: '75px' }}>
                        {row.school_class.term.name}
                    </Tag>
                    {row.school_class.name}
                    {row.is_primary && <FlagOutlined className='ml-2' />}
                </div>
            );
        },
        title: 'クラス名',
        width: 150,
    },
    {
        key: 'roles',
        render: (_, row) => {
            return <div>{row.role.name}</div>;
        },
        title: '役割',
        width: 80,
    },
    {
        key: 'num',
        render: (_, row) => {
            return (
                <div>
                    {row.school_class.number}
                </div>
            );
        },
        title: '出席番号',
        width: 75,
    },
];